import React from "react";
import classNames from "classnames";

interface HiddenProps {
  children: React.ReactNode;
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
}

export function Hidden(props: HiddenProps) {
  const { children, xl, lg, md, sm, xs } = props;

  return (
    <div
      className={classNames({
        "hidden-xs": xs,
        "hidden-sm": sm,
        "hidden-md": md,
        "hidden-lg": lg,
        "hidden-xl": xl,
      })}
    >
      {children}
    </div>
  );
}
